import en from './en.json'
import nl from './nl.json'
import de from './de.json'

export const i18n = {
    en,
    nl,
    de
};

export default i18n;